module.exports = __webpack_public_path__ + "img/bannerrg.85ec3828.jpg";